import { Component, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, take, map } from 'rxjs';
import { BudgetUpdateModel } from 'src/app/models/budget-update.model';
import { BudgetModel } from 'src/app/models/budget.model';
import { InterestRateModel } from 'src/app/models/interestRate.model';
import { BudgetService } from 'src/app/services/budget.service';
import { ToastService } from 'src/app/services/toast.service';

import { BudgetModel1Component } from './budget-model-1/budget-model-1.component';
import { BudgetModelFinesaComponent } from './budget-model-finesa/budget-model-finesa.component';
import { BudgetModelLaguneComponent } from './budget-model-lagune/budget-model-lagune.component';

@Component({
    selector: 'app-budget',
    templateUrl: './budget.component.html',
    styleUrls: ['./budget.component.scss'],
    imports: [BudgetModel1Component, BudgetModelFinesaComponent, BudgetModelLaguneComponent]
})
export class BudgetComponent {
  budgetSvc = inject(BudgetService);
  activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);
  toastr = inject(ToastService);


  currentInterestRates: InterestRateModel[] = [];
  day: string = '';
  month: string = '';
  year: string = '';
  budget!: BudgetModel;
  budgetId!: string;
  disableSubmit: boolean = false;

  interestForm = new FormGroup({
    minimumCashDownPayment: new FormControl(),
  });

  minPayReceived: number = 0;
  valCuota: number = 0;
  cuotaRedondeada: number = 0;
  fundingInstallmentsTemp: { id: string; price: number }[] = [];
  optionalAccessoriesTemp: { id: string; price: number | string }[] = [];
  installationMaterialsTemp: { id: string; value: string }[] = [];
  updateBudget: BudgetUpdateModel = {
    minimumCashDownPayment: 0,
    fundingInstallments: [],
    optionalAccessories: [],
    installationMaterials: [],
  };
  isCompleted: boolean = false;

  ngOnInit() {
    this.getBudgetId().subscribe((id) => {
      if (id) {
        this.budgetId = id;
        this.getBudget(id);
      } else {
        this.toastr.error('Error', 'No se encontró el ID del presupuesto en los parámetros de la consulta.');
      }
    });
  }

  getBudgetId(): Observable<string | null> {

    return this.activatedRoute.queryParams.pipe(take(1),
      map((params) => {
        this.isCompleted = params['isCompleted'] === 'true';
        const { isCompleted, ...queryParams } = params;

        this.router.navigate(['.'], {
          relativeTo: this.activatedRoute,
          queryParams: queryParams,
          replaceUrl: true, // same page: no extra history entry for Back/Volver to land on
        });
        return params['id'] || null;
      }));
  }

  getBudget(id: string) {
    this.budgetSvc.getBudgetById(id).subscribe({
      next: (data) => {
        this.budget = data;
        this.dateFormater(data.budgetDate.toString());
        this.optionalAccessoriesTemp = data.optionalAccessories.map((item) => {
          if (item.isPromotionalAccessory) {
            return {
              id: item.id.toString(),
              price: 0,
            };
          } else {
            return {
              id: item.id.toString(),
              price: item.price,
            };
          }
        });
        data.notInBudget.forEach((x) => {
          if (x.items.length > 0) {
            this.installationMaterialsTemp = x.items.map((material) => ({
              id: material.id.toString(),
              value: material.value,
            }));
          }
        });
        this.interestForm.controls.minimumCashDownPayment.patchValue(
          this.budget.minimumCashDownPayment
        );
      },
    });
  }

  dateFormater(date: string) {
    const fecha = new Date(date.split('T')[0]);
    const fechaFormateada = fecha.toISOString().split('T')[0];
    const [year, month, day] = fechaFormateada.split('-');

    this.day = day;
    this.month = month;
    this.year = year;
  }
}
